var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPropertyIconManufactured(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    transform: "translate(362 773)",
    fill: "red"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-362 -773)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.155,3a.609.609,0,0,0-.516.286L1.593,8.159a.609.609,0,0,0,.516.933H18.1a.609.609,0,0,0,.516-.933L15.571,3.286A.609.609,0,0,0,15.055,3h-9.9Zm1.1,1.218h8.462L17,7.874H8.539Zm-1.1.54L7.1,7.874H3.209ZM2.109,10.311a.609.609,0,0,0-.609.609v6.092a.609.609,0,0,0,.609.609H8.2a.609.609,0,0,0,.609-.609V10.92a.609.609,0,0,0-.609-.609Zm8.529,0a.609.609,0,0,0-.609.609v6.092a.609.609,0,0,0,.609.609h7.311a.609.609,0,0,0,.609-.609V10.92a.609.609,0,0,0-.609-.609Zm-7.92,1.218H7.592V16.4H2.718Zm8.529,0h6.092V16.4H11.247Z",
    transform: "translate(361.896 772.689)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPropertyIconManufactured);
export default __webpack_public_path__ + "static/media/property-icon-manufactured.1fe5c432edc937b5f4295d9857d85ae8.svg";
export { ForwardRef as ReactComponent };